import type { PostAJobData } from '../types';

export const UPDATE_POST_A_JOB = 'UPDATE_POST_A_JOB';

export const updatePostAJob = (payload: PostAJobData) => ({
    type: UPDATE_POST_A_JOB,
    payload,
});

export default (state: PostAJobData = { isVisible: false, qaList: [] }, action): PostAJobData =>
    action.type === UPDATE_POST_A_JOB ? action.payload : state;
